import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/staylinked': {
    width: 440,
    height: 512,
    paths: [
      {
        d: 'M382.7 292.5l44.3 41.3c3.7 3.5 3.3 9-0.7 12.2l-198 163.9c-9.9 7.6-17.3 0.8-17.3 0.8l-208.7-196.1c-3.5-3.5-3-9 1.2-12.2l45.8-34.9c4.2-3.2 10.4-3 13.9 0.5l151.9 147.5c3.7 3.5 10 3.7 14.2 0.4l93.2-74c4.1-3.2 4.5-8.7 0.9-12.2l-84-81.3c-3.6-3.5-9.9-3.7-14-0.5l-0.1 0.1c-4.1 3.2-10.4 3-14-0.5l-68.1-64.3c-3.5-3.5-3.1-9 1.1-12.2l57.3-43.6c4.1-3.2 10.3-3 13.8 0.5l170 167.3zM437.2 209.1c3.7 3.5 3.4 9-0.7 12.2l-45.8 35.8c-4.1 3.2-10.4 3-14.1-0.5l-160.4-159c-3.6-3.5-9.8-3.7-13.9-0.5l-92.2 71.5c-4.2 3.3-4.7 8.7-1.1 12.2l94.6 91.8c3.7 3.5 10 3.6 14.2 0.4l0.1-0.1c4.2-3.2 10.6-3 14.2 0.5l57.1 54.4c3.7 3.5 3.3 9-0.9 12.2l-7.7 6 0.3 0.3-50.2 38.8c-4.2 3.3-10.6 3.1-14.3-0.4l-171.7-165.1-42.3-41.7c-3.6-3.5-3-9 1.2-12.2l206.8-162.1c8.3-6.6 14.8-2.3 16.3-1.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/staylinked.js
// module id = 1034
// module chunks = 0